import React, { useCallback, useEffect, useState } from 'react';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Box from '@mui/joy/Box';


///////////// Date Formate
import dateFormat, { masks } from "dateformat";
import dayjs from 'dayjs';


/////////////////////Date Piker
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Numbers } from '@mui/icons-material';

export default function StepThree({
    getDataFromStepThreeYearMade,
    getDataFromStepThreeYearsValues,
    yearMade,
    yearsPrice
}) {
    const [valuesYears, setValuesYears] = useState([])
    const [selectedDate, setSelectedDate] = useState(null);
    const submitYearMade = (data) => {
        getDataFromStepThreeYearMade(data.year())
        setSelectedDate(data)

    }

    const getOldData = useCallback(() => {
        setSelectedDate(dayjs(yearMade))
    }, [])

    console.log("setSelectedDate > ", selectedDate)

    const handleInputChange = (index, event) => {
        const newInputs = [...yearsPrice];
        newInputs[index]
            = event.target.value;
        setValuesYears(newInputs);
        getDataFromStepThreeYearsValues(newInputs)
    };

    useEffect(() => {
        getOldData();
    }, [])

    return (
        <Grid
            container
            direction='row'
            spacing={4}
        >
            <Grid xs={12} sx={{ marginBottom: '30px' }}>
                <FormControl sx={{ width: '20%' }}>
                    <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>سنة الصنع</FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        {/* <YearCalendar value={yearMade} onChange={submitYearMade}/> */}
                        <DatePicker views={['year']} value={selectedDate} onChange={submitYearMade} />
                    </LocalizationProvider>
                </FormControl>
            </Grid>
            <Grid xs={12}>
                <Typography level="h3" sx={{ fontSize: '16px', color: '#434448' }}>نسبة انخفاض السعر على مدار السنوات</Typography>
            </Grid>
            <Grid xs={12}>
                <Box component="section" sx={{ display: 'flex', width: '100%', gap: '20px', flexWrap: 'wrap' }}>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة الاولى</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[0]}
                            onChange={(e) => handleInputChange(0, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة الثانية</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[1]}
                            onChange={(e) => handleInputChange(1, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة الثالثة</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[2]}
                            onChange={(e) => handleInputChange(2, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة الرابعة</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[3]}
                            onChange={(e) => handleInputChange(3, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة الخامسة</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[4]}
                            onChange={(e) => handleInputChange(4, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة السادسة</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[5]}
                            onChange={(e) => handleInputChange(5, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة السابعة</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[6]}
                            onChange={(e) => handleInputChange(6, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة الثامنة</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[7]}
                            onChange={(e) => handleInputChange(7, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة التاسعة</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[8]}
                            onChange={(e) => handleInputChange(8, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة العاشرة</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[9]}
                            onChange={(e) => handleInputChange(9, e)}
                        />
                    </FormControl>
                    {/* <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة الحادية عشر</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[10]}
                            onChange={(e) => handleInputChange(10, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة الثانية عشر</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[11]}
                            onChange={(e) => handleInputChange(11, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '20%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>السنة الثالثة عشر</FormLabel>
                        <Input
                            placeholder="00.00"
                            type='number'
                            sx={{ borderRadius: '30px', height: '60px' }}
                            value={yearsPrice[12]}
                            onChange={(e) => handleInputChange(12, e)}
                        />
                    </FormControl> */}
                </Box>
            </Grid>
        </Grid>
    );
}